import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CURATION_STATUS } from 'domains/merchant-inbound/constants'


const propTypes = {
  curation_status: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Inbound `curation_status`.
 * It maps `curation_status` to certain style and pass to `StatusBadge`.
 * @param {string} curation_status
 */
const MerchantInboundCurationStatusBadge = ({ curation_status }) => {

  const colorMap = {
    [CURATION_STATUS.PENDING]          : 'warning',
    [CURATION_STATUS.PHYSICAL_CURATED] : 'primary',
    [CURATION_STATUS.PHOTO_CURATED]    : 'success'
  }

  const color = colorMap[curation_status] || 'default'

  return <StatusBadge color={ color } label={ curation_status } />
}

MerchantInboundCurationStatusBadge.propTypes = propTypes

export default MerchantInboundCurationStatusBadge
